import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { postRequest } from "./axios";

type TypeOperatore = {
  idoperatorecantiere: string | null;
  nomecognome: string | null;
  numerotelefono: string | null;
  immagine_profilo?: string | null;
};

export const useOperatori = ({

  idoperatorecantiere = null,
  nomecognome = null,
  numerotelefono = null

}: {

  idoperatorecantiere?: string | null; 
  nomecognome?: string | null; 
  numerotelefono?: string | null; 

}) => {
  const [isLoading, setLoadingStatus] = useState<boolean>(true);
  const [results, setResults] = useState<Array<TypeOperatore>>([]);

  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    scaricaOperatori();
  }, []);

  const scaricaOperatori = async () => {
    try {
      const result = await postRequest("/operatori/get_operatori", {
        idoperatorecantiere,
      });

      setResults(result.data);
      setLoadingStatus(false);
    } catch (e) {
      navigate("/");
      enqueueSnackbar("Impossibile ottenere i dati degli operatori: " + e, {
        variant: "error",
      });
    }
  };

  return { results, isLoading, setLoadingStatus, setResults };
};

export const updatePhoneNumber = async (
  idoperatorecantiere: string = "",
  newPhoneNumber: string = ""
) => {
  try {
    const result = await postRequest("/operatori/update_phone_number", {
      idoperatorecantiere: idoperatorecantiere,
      phonenumber: newPhoneNumber,
    });

    return result.data; 

  } catch (e: any) {
    throw new Error(
      "Impossibile aggiornare il numero di telefono delloperatore: " + e.message
        ? e.message
        : e
    );
  }
};
